import { render, staticRenderFns } from "./WindingInsolvencyForms.vue?vue&type=template&id=c17ad876&scoped=true&"
import script from "./WindingInsolvencyForms.vue?vue&type=script&lang=js&"
export * from "./WindingInsolvencyForms.vue?vue&type=script&lang=js&"
import style0 from "./WindingInsolvencyForms.vue?vue&type=style&index=0&id=c17ad876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17ad876",
  null
  
)

export default component.exports